<template>
<div>
    <Breadcrumbs main="Admin" submain="Details" title="What We Do" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card v-if="!loading && !error">
                    <div slot="with-padding">
                        <div class="form theme-form">

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input class="form-control" type="text" placeholder="Enter title" v-model="details.title">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Type</label>
                                        <select class="form-control digits" v-model="details.type">
                                            <option v-for="(type, index) in whatwedoType" :key="index" :value="type.value">{{ type.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Short Description</label>
                                        <input class="form-control" type="text" placeholder="Enter short description" v-model="details.short">
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <ckeditor :editor="editor" placeholder="Enter description..." v-model="details.description"></ckeditor>
                                        
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Image</label>
                                        <div class="flex items-center">
                                            <img v-if="show_image" style="height: 80px;" :src="show_image">
                                            <input :class="details.image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="uploadFile">
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>2nd Image</label>
                                        <div class="flex items-center">
                                            <img v-if="show_image2" style="height: 80px;" :src="show_image2">
                                            <input :class="details.image2 ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="uploadFile2">
                                        </div>
                                    </div>
                                </div> -->

                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                       
                                        <button v-if="this.$route.params.type !== 'new'" @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Update</button>
                                        <button v-else @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                        <router-link to="/admin/what-we-do">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </px-card>
                <px-card v-else>
                    <div slot="with-padding">
                        <loader />
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import treeVue from '../../advance/tree.vue';
import loader from '../loader/loader.vue'
import {
    myHost
} from '../../../_helpers/host'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        loader,
    },

    data() {
        return {
            host: myHost.host,
            isDisabled: false,
            editor: ClassicEditor,
            details: {
                title: null,
                description: null,
                short: null,
                image: null,
                image2: null,
                type : null

            },
            show_image: null,
            show_image2: null,

            whatwedoType: [{
                    name: 'Research',
                    value: 'research'
                },
                {
                    name: 'Advocay',
                    value: 'advocacy'
                },

                {
                    name: 'SDGS',
                    value: 'sdgs'
                },
                {
                    name: 'Citizen Engagement',
                    value: 'citizen_engagement'
                },
                {
                    name: 'Stakeholder Engagement',
                    value: 'stakeholder_engagement'
                }

            ],

        };
    },

    watch: {
        whatwedoDetails(oldValue, newValue) {
            this.details.title = this.whatwedoDetails.title ? this.whatwedoDetails.title : null
            this.details.type = this.whatwedoDetails.type ? this.whatwedoDetails.type : null
            this.details.description = this.whatwedoDetails.description ? this.whatwedoDetails.description : null
            this.details.short = this.whatwedoDetails.short ? this.whatwedoDetails.short : null
           
            this.show_image = this.whatwedoDetails.image ? this.host + this.whatwedoDetails.image : null
            this.show_image2 = this.whatwedoDetails.image2 ? this.host + this.whatwedoDetails.image2 : null

        },
    },

    computed: {
        ...mapState({
            whatwedoDetails: state => state.whatWeDo.what_we_do_detail,
            loading: state => state.whatWeDo.what_we_do_Loading,
            error: state => state.whatWeDo.what_we_do_Error,
        }),

    },

    mounted() {
        if (this.$route.params.type !== 'new') {
            this.$store.dispatch("whatWeDo/fetchWhatDoDetail", this.$route.params.type)
            this.details.type = this.$route.params.type
        }else {

        }

    },

    methods: {

        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.details.image = e.target.result;
            };
        },
        uploadFile2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image2 = e.target.result
                this.details.image2 = e.target.result;
            };
        },

        onSubmit() {
            this.isDisabled = true

            this.$store.dispatch("whatWeDo/addWhatDO", {
                what_we_do: this.details,
                type: this.details.type
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.isDisabled = false,
                        this.details.title= null,
                        this.details.short = null,
                        this.details.description= null,
                        this.details.image = null,
                        this.details.image2 =  null,
                        this.details.type = null

                        setTimeout(() => {
                            this.$router.push('/admin/what-we-do')
                        }, 2000)

                } else {
                    this.isDisabled = false
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }

            })
        }
    }
};
</script>
